<script setup lang="ts">
import type { ProgressRootProps } from 'reka-ui'
import { ProgressIndicator, ProgressRoot, useForwardProps } from 'reka-ui'

const props = defineProps<ProgressRootProps>()

const forwarded = useForwardProps(props)
</script>

<template>
  <ProgressRoot
    v-slot="{ modelValue }"
    v-bind="forwarded"
    class="border-muted bg-gray-10 relative h-5 w-full overflow-hidden rounded-xl p-0.5"
  >
    <ProgressIndicator
      class="bg-green-40 ease-[cubic-bezier(0.65, 0, 0.35, 1)] block h-full rounded-lg transition-all duration-[660ms]"
      :style="{ width: `${modelValue}%` }"
    />
  </ProgressRoot>
</template>
